<script>
  import { setContext } from 'svelte'
  import WorkIdScreen from '../../../../../module_core/module_portfolio/screen/workId/WorkIdScreen.svelte'

  // @ts-ignore
  const { data } = $props()

  setContext('work_page', data)
</script>

<svelte:head>
  <title>{data.work.metadata.title || ''}</title>

  {#if data.work.metadata.description}
    <meta title="description" content={data.work.metadata.description || ''} />
  {/if}
</svelte:head>

<WorkIdScreen />
